class ProductLampshadesTrigger extends window.BAO.DrawerTrigger {
  /**
   * @param {ProductLampshadesOption} option
   */
  updateSelectedDisplay (option) {
    this.els.selected.element.innerHTML = option.getDisplayText()

    this.updateImage(this.image, option.getImages().main)
  }
}

if (!customElements.get('product-lampshades-trigger')) {
  customElements.define('product-lampshades-trigger', ProductLampshadesTrigger)
}
